(() => {
  if (window.AKCrystalBuilderV60Installed) return;
  window.AKCrystalBuilderV60Installed = true;

  const GIFT_VARIANT_ID = 56666961740100;
  const FI_THRESHOLDS = {
    gift: 2500,
    halfShipping: 0,
    shipping: 6000
  };

  const $ = (parent, selector) =>
    parent.querySelector(selector);

  const $$ = (parent, selector) =>
    Array.from(
      parent.querySelectorAll(selector)
    );

  const root = () =>
    window.Shopify?.routes?.root || '/';

  const rowsOf = builder =>
    $$(
      builder,
      '[data-ak-builder-item]'
    );

  function formatLabel(
    template,
    values = {}
  ) {
    let output =
      String(template || '');

    Object.entries(values)
      .forEach(([key, value]) => {
        output =
          output.replaceAll(
            `__${key.toUpperCase()}__`,
            String(value)
          );
      });

    return output;
  }

  function pluralCategory(count) {
    try {
      return new Intl.PluralRules(
        document.documentElement.lang ||
        'fi-FI'
      ).select(count);
    } catch (_) {
      return count === 1
        ? 'one'
        : 'other';
    }
  }

  function pluralTemplate(
    builder,
    prefix,
    count
  ) {
    const category =
      pluralCategory(count);

    const key =
      prefix +
      category
        .charAt(0)
        .toUpperCase() +
      category.slice(1);

    return (
      builder.dataset[key] ||
      builder.dataset[
        prefix + 'Other'
      ] ||
      ''
    );
  }

  function money(
    builder,
    cents
  ) {
    try {
      return new Intl.NumberFormat(
        document.documentElement.lang ||
        'fi-FI',
        {
          style: 'currency',
          currency:
            builder.dataset.currency ||
            'EUR'
        }
      ).format(
        Number(cents || 0) / 100
      );
    } catch (_) {
      return (
        Number(cents || 0) / 100
      ).toFixed(2) + ' €';
    }
  }

  function getBenefitThresholds() {
    const isFinnishStore =
      window.location.hostname
        .includes(
          'ametistikissa.fi'
        );

    if (isFinnishStore) {
      return {
        gift:
          FI_THRESHOLDS.gift,

        halfShipping:
          FI_THRESHOLDS
            .halfShipping,

        shipping:
          FI_THRESHOLDS.shipping,

        hasHalfShipping:
          false
      };
    }

    const current =
      window.ACBenefits?.current;

    if (!current) {
      return null;
    }

    const gift =
      Number(
        current.giftCents
      );

    const halfShipping =
      Number(
        current.halfShippingCents
      );

    const shipping =
      Number(
        current.freeShippingCents
      );

    if (
      !Number.isFinite(gift) ||
      !Number.isFinite(
        halfShipping
      ) ||
      !Number.isFinite(
        shipping
      ) ||
      gift <= 0 ||
      halfShipping <= 0 ||
      shipping <= 0
    ) {
      console.warn(
        'AK Builder: invalid benefit thresholds',
        current
      );

      return null;
    }

    return {
      gift,
      halfShipping,
      shipping,
      hasHalfShipping: true
    };
  }

  function isAutomaticGift(item) {
    return (
      Number(
        item.variant_id
      ) ===
        GIFT_VARIANT_ID &&
      (
        String(
          item.properties
            ?._auto_gift
        ) === 'true' ||

        String(
          item.properties
            ?._ak_free_gift
        ) === 'true'
      )
    );
  }

  function isGiftCard(item) {
    return (
      item?.gift_card === true
    );
  }

  function isAdventCalendar(
    item
  ) {
    return (
      item?.product_type ===
        'Advent Calendar' ||

      item?.product_type ===
        'Joulukalenteri'
    );
  }

  function getQualifyingCartTotals(
    cart
  ) {
    let gift = 0;
    let shipping = 0;

    (cart.items || [])
      .forEach(item => {
        if (
          isAutomaticGift(item) ||
          isGiftCard(item)
        ) {
          return;
        }

        const price =
          Number(
            item.final_line_price ??
            item.line_price ??
            item.original_line_price ??
            0
          );

        if (
          !Number.isFinite(price)
        ) {
          return;
        }

        shipping += price;

        if (
          !isAdventCalendar(
            item
          )
        ) {
          gift += price;
        }
      });

    return {
      gift,
      shipping
    };
  }

  async function fetchCart() {
    const response =
      await fetch(
        root() + 'cart.js',
        {
          credentials:
            'same-origin',

          cache:
            'no-store',

          headers: {
            Accept:
              'application/json'
          }
        }
      );

    if (!response.ok) {
      throw new Error(
        'AK Builder: cart fetch ' +
        response.status
      );
    }

    return response.json();
  }

  function getSelected(
    builder
  ) {
    const ids = [];
    let total = 0;

    const cartIds =
      builder.akCartVariantIds ||
      new Set();

    const mainId =
      Number(
        builder.dataset
          .mainVariantId
      );

    const mainPrice =
      Number(
        builder.dataset
          .mainPrice
      );

    const mainAlreadyInCart =
      cartIds.has(mainId);

    if (
      !mainAlreadyInCart &&
      Number.isSafeInteger(
        mainId
      ) &&
      mainId > 0 &&
      Number.isSafeInteger(
        mainPrice
      ) &&
      mainPrice >= 0
    ) {
      ids.push(mainId);
      total += mainPrice;
    }

    rowsOf(builder)
      .forEach(row => {
        const checkbox =
          $(
            row,
            '[data-ak-builder-check]'
          );

        if (
          !checkbox?.checked
        ) {
          return;
        }

        const id =
          Number(
            row.dataset
              .variantId
          );

        const price =
          Number(
            row.dataset.price
          );

        if (
          !Number.isSafeInteger(
            id
          ) ||
          id <= 0 ||
          !Number.isSafeInteger(
            price
          ) ||
          price < 0 ||
          ids.includes(id) ||
          cartIds.has(id)
        ) {
          return;
        }

        ids.push(id);
        total += price;
      });

    return {
      ids,
      total,
      mainAlreadyInCart
    };
  }

  function calculateMilestone(
    builder,
    proposedTotal
  ) {
    const thresholds =
      getBenefitThresholds();

    if (!thresholds) {
      return {
        stage:
          'checking',

        remaining:
          0,

        progress:
          0,

        readyToEarn:
          false
      };
    }

    const actualGift =
      Number.isFinite(
        builder
          .akCartGiftSubtotal
      )
        ? builder
            .akCartGiftSubtotal
        : 0;

    const actualShipping =
      Number.isFinite(
        builder
          .akCartShippingSubtotal
      )
        ? builder
            .akCartShippingSubtotal
        : 0;

    const proposed =
      builder
        .akPreviewPending !==
        false
        ? proposedTotal
        : 0;

    if (
      actualGift <
      thresholds.gift
    ) {
      const projected =
        actualGift +
        proposed;

      return {
        stage:
          'gift',

        remaining:
          Math.max(
            0,
            thresholds.gift -
            projected
          ),

        progress:
          Math.min(
            100,
            Math.round(
              projected /
              thresholds.gift *
              100
            )
          ),

        readyToEarn:
          projected >=
          thresholds.gift
      };
    }

    if (
      thresholds
        .hasHalfShipping &&
      actualShipping <
        thresholds.halfShipping
    ) {
      const projected =
        actualShipping +
        proposed;

      return {
        stage:
          'half_shipping',

        remaining:
          Math.max(
            0,
            thresholds
              .halfShipping -
            projected
          ),

        progress:
          Math.min(
            100,
            Math.round(
              projected /
              thresholds
                .halfShipping *
              100
            )
          ),

        readyToEarn:
          projected >=
          thresholds
            .halfShipping
      };
    }

    const projected =
      actualShipping +
      proposed;

    if (
      projected <
      thresholds.shipping
    ) {
      return {
        stage:
          'shipping',

        remaining:
          thresholds.shipping -
          projected,

        progress:
          Math.min(
            100,
            Math.round(
              projected /
              thresholds.shipping *
              100
            )
          ),

        readyToEarn:
          false
      };
    }

    return {
      stage:
        'complete',

      remaining:
        0,

      progress:
        100,

      readyToEarn:
        true,

      shippingAlreadyEarned:
        actualShipping >=
        thresholds.shipping
    };
  }

  function refreshSummary(
    builder
  ) {
    const {
      ids,
      total,
      mainAlreadyInCart
    } =
      getSelected(
        builder
      );

    const mainStatus =
      $(
        builder,
        '[data-ak-main-status]'
      );

    if (mainStatus) {
      mainStatus.textContent =
        mainAlreadyInCart
          ? builder.dataset
              .labelMainInCart ||
            ''
          : builder.dataset
              .labelBase ||
            '';

      mainStatus
        .classList
        .toggle(
          'is-in-cart',
          mainAlreadyInCart
        );
    }

    const totalElement =
      $(
        builder,
        '[data-ak-builder-total]'
      );

    if (totalElement) {
      totalElement
        .textContent =
        money(
          builder,
          total
        );
    }

    const countElement =
      $(
        builder,
        '[data-ak-builder-count]'
      );

    if (countElement) {
      countElement
        .textContent =
        formatLabel(
          pluralTemplate(
            builder,
            'labelProduct',
            ids.length
          ),
          {
            count:
              ids.length
          }
        );
    }

    const addButton =
      $(
        builder,
        '[data-ak-builder-add]'
      );

    if (
      addButton &&
      builder.dataset
        .akBuilderAdding !==
        'true'
    ) {
      addButton.textContent =
        formatLabel(
          pluralTemplate(
            builder,
            'labelAddSet',
            ids.length
          ),
          {
            count:
              ids.length,

            amount:
              money(
                builder,
                total
              )
          }
        );

      addButton.disabled =
        ids.length === 0;
    }

    rowsOf(builder)
      .forEach(row => {
        const checkbox =
          $(
            row,
            '[data-ak-builder-check]'
          );

        row.classList
          .toggle(
            'is-selected',
            Boolean(
              checkbox?.checked
            )
          );
      });

    const milestone =
      calculateMilestone(
        builder,
        total
      );

    const text =
      $(
        builder,
        '[data-ak-builder-gift-text]'
      );

    if (text) {
      if (
        milestone.stage ===
        'checking'
      ) {
        text.textContent = '';
      }

      else if (
        milestone.stage ===
        'gift'
      ) {
        text.textContent =
          milestone
            .readyToEarn
            ? builder.dataset
                .labelGiftReady ||
              ''
            : formatLabel(
                builder.dataset
                  .labelGiftRemaining,
                {
                  amount:
                    money(
                      builder,
                      milestone
                        .remaining
                    )
                }
              );
      }

      else if (
        milestone.stage ===
        'half_shipping'
      ) {
        const template =
          milestone
            .readyToEarn
            ? builder.dataset
                .labelHalfShippingReady
            : (
                builder.dataset
                  .labelHalfShippingPreview ||
                builder.dataset
                  .labelHalfShippingRemaining
              );

        text.textContent =
          formatLabel(
            template,
            {
              amount:
                money(
                  builder,
                  milestone
                    .remaining
                )
            }
          );
      }

      else if (
        milestone.stage ===
        'shipping'
      ) {
        text.textContent =
          formatLabel(
            builder
              .akPreviewPending !==
              false
              ? builder.dataset
                  .labelShippingPreview
              : builder.dataset
                  .labelShippingRemaining,
            {
              amount:
                money(
                  builder,
                  milestone
                    .remaining
                )
            }
          );
      }

      else {
        text.textContent =
          milestone
            .shippingAlreadyEarned
            ? builder.dataset
                .labelCompleteEarned ||
              ''
            : builder.dataset
                .labelCompletePreview ||
              '';
      }
    }

    const progress =
      $(
        builder,
        '[data-ak-builder-progress]'
      );

    const fill =
      $(
        builder,
        '[data-ak-builder-progress-fill]'
      );

    if (progress) {
      progress.setAttribute(
        'aria-valuenow',
        String(
          milestone.progress
        )
      );

      let label =
        builder.dataset
          .labelProgressComplete ||
        '';

      if (
        milestone.stage ===
        'gift'
      ) {
        label =
          builder.dataset
            .labelProgressGift ||
          label;
      }

      if (
        milestone.stage ===
        'half_shipping'
      ) {
        label =
          builder.dataset
            .labelProgressHalfShipping ||
          label;
      }

      if (
        milestone.stage ===
        'shipping'
      ) {
        label =
          builder.dataset
            .labelProgressShipping ||
          label;
      }

      progress.setAttribute(
        'aria-label',
        label
      );
    }

    if (fill) {
      fill.style.width =
        milestone.progress +
        '%';
    }

    const benefitBox =
      $(
        builder,
        '.ak-builder__gift'
      );

    if (benefitBox) {
      benefitBox.dataset
        .akMilestone =
        milestone.stage;
    }

    builder
      .akSelectedVariants =
      ids;

    builder
      .akSelectedTotal =
      total;
  }

  function candidatesOf(
    builder
  ) {
    const mainId =
      Number(
        builder.dataset
          .mainVariantId
      );

    const seen =
      new Set([
        mainId
      ]);

    return rowsOf(builder)
      .map(
        (row, index) => ({
          row,

          id:
            Number(
              row.dataset
                .variantId
            ),

          price:
            Number(
              row.dataset.price
            ),

          role:
            row.dataset.akRole,

          crystalKey:
            row.dataset
              .crystalKey ||
            '',

          index
        })
      )
      .filter(
        candidate => {
          if (
            !Number
              .isSafeInteger(
                candidate.id
              ) ||

            candidate.id <= 0 ||

            !Number
              .isSafeInteger(
                candidate.price
              ) ||

            candidate.price < 0 ||

            ![
              'stone',
              'bowl'
            ].includes(
              candidate.role
            ) ||

            seen.has(
              candidate.id
            )
          ) {
            return false;
          }

          seen.add(
            candidate.id
          );

          return true;
        }
      );
  }

  function hashString(value) {
    let hash =
      2166136261;

    const text =
      String(
        value || ''
      );

    for (
      let i = 0;
      i < text.length;
      i++
    ) {
      hash ^=
        text.charCodeAt(i);

      hash =
        Math.imul(
          hash,
          16777619
        );
    }

    return hash >>> 0;
  }

  function productSpecificOrder(
    builder,
    candidates
  ) {
    const seed =
      [
        builder.dataset
          .productId ||
        '',

        builder.dataset
          .mainCrystalKey ||
        ''
      ].join('|');

    return [
      ...candidates
    ]
      .map(
        candidate => ({
          candidate,

          rank:
            hashString(
              [
                seed,
                candidate
                  .crystalKey,
                candidate.role,
                candidate.id
              ].join('|')
            )
        })
      )
      .sort(
        (a, b) =>
          a.rank -
            b.rank ||
          a.candidate.id -
            b.candidate.id
      )
      .map(
        entry =>
          entry.candidate
      );
  }

  const PRESETS = {
    small: {
      min: 1000,
      ideal: 1500,
      max: 2000,
      minStones: 2,
      maxStones: 4,
      bowl: false
    },

    medium: {
      min: 2500,
      ideal: 2900,
      max: 3500,
      minStones: 2,
      maxStones: 5,
      bowl: true
    },

    large: {
      min: 4500,
      ideal: 5600,
      max: 6000,
      minStones: 5,
      maxStones: 13,
      bowl: true
    }
  };

  function scoreBundle(
    total,
    count,
    target,
    bowlCount,
    hasBowl,
    diversityPenalty
  ) {
    const inRange =
      total >=
        target.min &&
      total <=
        target.max;

    const outside =
      total <
        target.min
        ? target.min -
          total
        : total >
            target.max
          ? total -
            target.max
          : 0;

    const distance =
      inRange
        ? Math.abs(
            total -
            target.ideal
          )
        : outside;

    const bowlPenalty =
      target.bowl &&
      hasBowl &&
      bowlCount === 0
        ? 35000
        : 0;

    const tooSmallPenalty =
      count <
      target.minStones
        ? 20000
        : 0;

    return (
      (
        inRange
          ? 0
          : 75000
      ) +

      bowlPenalty +

      tooSmallPenalty +

      distance * 10 +

      count * 18 +

      diversityPenalty
    );
  }

  function findPreset(
    builder,
    size
  ) {
    const target =
      PRESETS[size] ||
      PRESETS.medium;

    const mainId =
      Number(
        builder.dataset
          .mainVariantId
      );

    const mainPrice =
      Number(
        builder.dataset
          .mainPrice
      ) || 0;

    const mainCrystalKey =
      builder.dataset
        .mainCrystalKey ||
      '';

    const inCart =
      builder
        .akCartVariantIds ||
      new Set();

    const mainAlreadyInCart =
      inCart.has(
        mainId
      );

    const available =
      productSpecificOrder(
        builder,
        candidatesOf(builder)
          .filter(
            candidate =>
              !inCart.has(
                candidate.id
              )
          )
      );

    const bowls =
      available
        .filter(
          candidate =>
            candidate.role ===
            'bowl'
        );

    const stones =
      available
        .filter(
          candidate =>
            candidate.role ===
            'stone'
        )
        .slice(
          0,
          14
        );

    const selectedBowl =
      target.bowl
        ? bowls.slice(
            0,
            1
          )
        : [];

    const bowlPrice =
      selectedBowl
        .reduce(
          (
            sum,
            item
          ) =>
            sum +
            item.price,
          0
        );

    const masks =
      1 <<
      stones.length;

    let best =
      null;

    for (
      let mask = 0;
      mask < masks;
      mask++
    ) {
      let fullTotal =
        mainPrice +
        bowlPrice;

      let addTotal =
        (
          mainAlreadyInCart
            ? 0
            : mainPrice
        ) +
        bowlPrice;

      let count = 0;
      let order = 0;
      let valid = true;

      const selected =
        [
          ...selectedBowl
        ];

      const usedCrystals =
        new Set();

      if (
        mainCrystalKey
      ) {
        usedCrystals
          .add(
            mainCrystalKey
          );
      }

      for (
        let i = 0;
        i < stones.length;
        i++
      ) {
        if (
          !(
            mask &
            (
              1 << i
            )
          )
        ) {
          continue;
        }

        const stone =
          stones[i];

        if (
          stone.crystalKey &&
          usedCrystals
            .has(
              stone.crystalKey
            )
        ) {
          valid = false;
          break;
        }

        if (
          stone.crystalKey
        ) {
          usedCrystals
            .add(
              stone.crystalKey
            );
        }

        count++;

        fullTotal +=
          stone.price;

        addTotal +=
          stone.price;

        selected.push(
          stone
        );

        order += i;
      }

      if (
        !valid ||
        count >
          target.maxStones
      ) {
        continue;
      }

      if (
        count <
        Math.min(
          target.minStones,
          stones.length
        )
      ) {
        continue;
      }

      const score =
        scoreBundle(
          fullTotal,
          count,
          target,
          selectedBowl.length,
          bowls.length > 0,
          order
        );

      if (
        !best ||
        score <
          best.score
      ) {
        best = {
          selected,
          total:
            addTotal,

          fullTotal,
          score,
          mainAlreadyInCart
        };
      }
    }

    return (
      best ||
      {
        selected:
          selectedBowl,

        total:
          (
            mainAlreadyInCart
              ? 0
              : mainPrice
          ) +
          bowlPrice,

        fullTotal:
          mainPrice +
          bowlPrice,

        score:
          Infinity,

        mainAlreadyInCart
      }
    );
  }

  function updateSizeLabels(
    builder
  ) {
    [
      'small',
      'medium',
      'large'
    ].forEach(
      size => {
        const recommendation =
          findPreset(
            builder,
            size
          );

        const element =
          $(
            builder,
            `[data-ak-size-count="${size}"]`
          );

        if (element) {
          element.textContent =
            money(
              builder,
              recommendation
                .total
            );
        }

        const button =
          $(
            builder,
            `[data-ak-builder-size="${size}"]`
          );

        if (button) {
          button.disabled =
            !recommendation
              .selected
              .length &&
            size !==
              'small';
        }
      }
    );
  }

  function clearRecentlyRemoved(
    builder
  ) {
    rowsOf(builder)
      .forEach(
        row =>
          row.classList
            .remove(
              'ak-builder--recently-removed'
            )
      );
  }

  function applyPreset(
    builder,
    size
  ) {
    const recommendation =
      findPreset(
        builder,
        size
      );

    const ids =
      new Set(
        recommendation
          .selected
          .map(
            item =>
              item.id
          )
      );

    rowsOf(builder)
      .forEach(row => {
        const input =
          $(
            row,
            '[data-ak-builder-check]'
          );

        if (input) {
          input.checked =
            ids.has(
              Number(
                row.dataset
                  .variantId
              )
            );
        }
      });

    $$(
      builder,
      '[data-ak-builder-size]'
    ).forEach(
      button => {
        const active =
          button.dataset
            .akBuilderSize ===
          size;

        button.classList
          .toggle(
            'is-active',
            active
          );

        button
          .setAttribute(
            'aria-pressed',
            String(active)
          );
      }
    );

    clearRecentlyRemoved(
      builder
    );

    builder
      .akPreviewPending =
      true;

    builder.classList
      .remove(
        'ak-builder--editing'
      );

    refreshSummary(
      builder
    );
  }

  function getNextBenefitTarget(
    builder
  ) {
    const thresholds =
      getBenefitThresholds();

    if (!thresholds) {
      return null;
    }

    const actualGift =
      Number.isFinite(
        builder
          .akCartGiftSubtotal
      )
        ? builder
            .akCartGiftSubtotal
        : 0;

    const actualShipping =
      Number.isFinite(
        builder
          .akCartShippingSubtotal
      )
        ? builder
            .akCartShippingSubtotal
        : 0;

    if (
      actualGift <
      thresholds.gift
    ) {
      return {
        stage:
          'gift',

        remaining:
          thresholds.gift -
          actualGift
      };
    }

    if (
      thresholds
        .hasHalfShipping &&
      actualShipping <
        thresholds
          .halfShipping
    ) {
      return {
        stage:
          'half_shipping',

        remaining:
          thresholds
            .halfShipping -
          actualShipping
      };
    }

    if (
      actualShipping <
      thresholds.shipping
    ) {
      return {
        stage:
          'shipping',

        remaining:
          thresholds.shipping -
          actualShipping
      };
    }

    return null;
  }

  function findTopUpStones(
    builder,
    targetAmount
  ) {
    const inCart =
      builder
        .akCartVariantIds ||
      new Set();

    const available =
  productSpecificOrder(
    builder,
    candidatesOf(builder)
      .filter(
        candidate =>
          candidate.role ===
            'stone' &&
          candidate.row.dataset
            .akIsHoroscope !==
            'true' &&
          !inCart.has(
            candidate.id
          )
      )
  )
  .slice(
    0,
    14
  );

    if (
      !available.length
    ) {
      return [];
    }

    const masks =
      1 <<
      available.length;

    let best = null;

    for (
      let mask = 1;
      mask < masks;
      mask++
    ) {
      let total = 0;
      let count = 0;
      let valid = true;

      const selected =
        [];

      const usedCrystals =
        new Set();

      for (
        let i = 0;
        i <
          available.length;
        i++
      ) {
        if (
          !(
            mask &
            (
              1 << i
            )
          )
        ) {
          continue;
        }

        const stone =
          available[i];

        if (
          stone.crystalKey &&
          usedCrystals.has(
            stone.crystalKey
          )
        ) {
          valid = false;
          break;
        }

        if (
          stone.crystalKey
        ) {
          usedCrystals.add(
            stone.crystalKey
          );
        }

        total +=
          stone.price;

        count++;

        selected.push(
          stone
        );

        if (
          count > 8
        ) {
          valid = false;
          break;
        }
      }

      if (!valid) {
        continue;
      }

      const reachesTarget =
        total >=
        targetAmount;

      const difference =
        Math.abs(
          total -
          targetAmount
        );

      const score =
        reachesTarget
          ? difference * 10 +
            count
          : 100000 +
            difference * 10 +
            count;

      if (
        !best ||
        score <
          best.score
      ) {
        best = {
          selected,
          total,
          score
        };
      }
    }

    return (
      best?.selected ||
      []
    );
  }

  function applyNextMilestoneRecommendations(
    builder
  ) {
    const target =
      getNextBenefitTarget(
        builder
      );

    rowsOf(builder)
      .forEach(row => {
        const checkbox =
          $(
            row,
            '[data-ak-builder-check]'
          );

        if (checkbox) {
          checkbox.checked =
            false;
        }

        row.classList
          .remove(
            'ak-builder--recently-removed'
          );
      });

    $$(
      builder,
      '[data-ak-builder-size]'
    ).forEach(
      button => {
        button.classList
          .remove(
            'is-active'
          );

        button
          .setAttribute(
            'aria-pressed',
            'false'
          );
      }
    );

    if (!target) {
      builder
        .akPreviewPending =
        false;

      refreshSummary(
        builder
      );

      return;
    }

    const ids =
      new Set(
        findTopUpStones(
          builder,
          target.remaining
        )
          .map(
            item =>
              item.id
          )
      );

    rowsOf(builder)
      .forEach(row => {
        const checkbox =
          $(
            row,
            '[data-ak-builder-check]'
          );

        if (checkbox) {
          checkbox.checked =
            ids.has(
              Number(
                row.dataset
                  .variantId
              )
            );
        }
      });

    builder
      .akPreviewPending =
      true;

    builder.classList
      .remove(
        'ak-builder--editing'
      );

    refreshSummary(
      builder
    );
  }

  let cartSyncPromise =
    null;

  async function syncCartTotals() {
    if (cartSyncPromise) {
      return cartSyncPromise;
    }

    cartSyncPromise =
      (
        async () => {
          const cart =
            await fetchCart();

          const totals =
            getQualifyingCartTotals(
              cart
            );

          $$(
            document,
            '[data-ak-builder][data-ak-builder-ready="true"]'
          ).forEach(
            builder => {
              builder
                .akCartGiftSubtotal =
                totals.gift;

              builder
                .akCartShippingSubtotal =
                totals.shipping;

              builder
                .akCartLoaded =
                true;

              builder
                .akCartVariantIds =
                new Set(
                  (
                    cart.items ||
                    []
                  )
                    .filter(
                      item =>
                        !isAutomaticGift(
                          item
                        )
                    )
                    .map(
                      item =>
                        Number(
                          item.variant_id
                        )
                    )
                );

              updateSizeLabels(
                builder
              );

              if (
                !builder
                  .akInitialCartApplied
              ) {
                builder
                  .akInitialCartApplied =
                  true;

                applyPreset(
                  builder,
                  'medium'
                );
              } else {
                refreshSummary(
                  builder
                );
              }
            }
          );

          return cart;
        }
      )();

    try {
      return await cartSyncPromise;
    }

    catch (error) {
      console.warn(
        'AK Builder: cart synchronization failed',
        error
      );

      return null;
    }

    finally {
      cartSyncPromise =
        null;
    }
  }

  function showError(
    builder,
    message
  ) {
    const element =
      $(
        builder,
        '[data-ak-builder-error]'
      );

    if (!element) {
      return;
    }

    element.textContent =
      message ||
      builder.dataset
        .errorLabel ||
      '';

    element.hidden =
      false;
  }

  function clearError(
    builder
  ) {
    const element =
      $(
        builder,
        '[data-ak-builder-error]'
      );

    if (!element) {
      return;
    }

    element.hidden =
      true;

    element.textContent =
      '';
  }

  async function addCollection(
    builder,
    button
  ) {
    if (
      builder.dataset
        .akBuilderAdding ===
      'true'
    ) {
      return;
    }

    const {
      ids
    } =
      getSelected(
        builder
      );

    if (!ids.length) {
      return;
    }

    clearError(
      builder
    );

    builder.dataset
      .akBuilderAdding =
      'true';

    button.disabled =
      true;

    button.setAttribute(
      'aria-busy',
      'true'
    );

    try {
      const response =
        await fetch(
          root() +
          'cart/add.js',
          {
            method:
              'POST',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json',

              'X-Requested-With':
                'XMLHttpRequest'
            },

            credentials:
              'same-origin',

            body:
              JSON.stringify({
                items:
                  ids.map(
                    id => ({
                      id,
                      quantity:
                        1
                    })
                  )
              })
          }
        );

      const data =
        await response.json();

      if (
        !response.ok ||
        data.status
      ) {
        throw new Error(
          data.description ||
          data.message ||
          builder.dataset
            .errorLabel ||
          ''
        );
      }

      builder
        .akPreviewPending =
        false;

      button.textContent =
        builder.dataset
          .addedLabel ||
        '';

      document.dispatchEvent(
        new CustomEvent(
          'cart:refresh',
          {
            detail: {
              source:
                'ak-crystal-builder'
            }
          }
        )
      );

      await syncCartTotals();

      applyNextMilestoneRecommendations(
        builder
      );
    }

    catch (error) {
      console.error(
        'AK Builder: add collection failed',
        error
      );

      showError(
        builder,
        error.message
      );
    }

    finally {
      button.removeAttribute(
        'aria-busy'
      );

      delete builder.dataset
        .akBuilderAdding;

      refreshSummary(
        builder
      );
    }
  }

  function initialize(
    builder
  ) {
    if (
      builder.dataset
        .akBuilderReady ===
      'true'
    ) {
      return;
    }

    if (
      !$(
        builder,
        '[data-ak-builder-panel]'
      )
    ) {
      return;
    }

    if (
      !rowsOf(builder).length
    ) {
      return;
    }

    builder.dataset
      .akBuilderReady =
      'true';

    builder
      .akPreviewPending =
      true;

    builder
      .akCartLoaded =
      false;

    builder
      .akCartVariantIds =
      new Set();

    updateSizeLabels(
      builder
    );

    applyPreset(
      builder,
      'medium'
    );

    syncCartTotals();
  }

  document.addEventListener(
    'click',
    event => {
      const sizeButton =
        event.target
          .closest?.(
            '[data-ak-builder-size]'
          );

      if (
        sizeButton &&
        !sizeButton.disabled
      ) {
        event.preventDefault();

        const builder =
          sizeButton.closest(
            '[data-ak-builder]'
          );

        if (builder) {
          applyPreset(
            builder,
            sizeButton.dataset
              .akBuilderSize
          );
        }

        return;
      }

      const addButton =
        event.target
          .closest?.(
            '[data-ak-builder-add]'
          );

      if (!addButton) {
        return;
      }

      event.preventDefault();

      const builder =
        addButton.closest(
          '[data-ak-builder]'
        );

      if (builder) {
        addCollection(
          builder,
          addButton
        );
      }
    }
  );

  document.addEventListener(
    'change',
    event => {
      const checkbox =
        event.target;

      if (
        !checkbox.matches?.(
          '[data-ak-builder-check]'
        )
      ) {
        return;
      }

      const builder =
        checkbox.closest(
          '[data-ak-builder]'
        );

      const row =
        checkbox.closest(
          '[data-ak-builder-item]'
        );

      if (!builder) {
        return;
      }

      if (row) {
        row.classList
          .toggle(
            'ak-builder--recently-removed',
            !checkbox.checked
          );
      }

      builder
        .akPreviewPending =
        true;

      $$(
        builder,
        '[data-ak-builder-size]'
      ).forEach(
        button => {
          button.classList
            .remove(
              'is-active'
            );

          button
            .setAttribute(
              'aria-pressed',
              'false'
            );
        }
      );

      refreshSummary(
        builder
      );
    }
  );

  document.addEventListener(
    'cart:refresh',
    event => {
      if (
        event.detail?.cart
      ) {
        const totals =
          getQualifyingCartTotals(
            event.detail.cart
          );

        $$(
          document,
          '[data-ak-builder][data-ak-builder-ready="true"]'
        ).forEach(
          builder => {
            builder
              .akCartGiftSubtotal =
              totals.gift;

            builder
              .akCartShippingSubtotal =
              totals.shipping;

            builder
              .akCartLoaded =
              true;

            builder
              .akCartVariantIds =
              new Set(
                (
                  event.detail
                    .cart.items ||
                  []
                )
                  .filter(
                    item =>
                      !isAutomaticGift(
                        item
                      )
                  )
                  .map(
                    item =>
                      Number(
                        item.variant_id
                      )
                  )
              );

            updateSizeLabels(
              builder
            );

            refreshSummary(
              builder
            );
          }
        );
      }

      else {
        syncCartTotals();
      }
    }
  );

  document.addEventListener(
    'ac:benefits-updated',
    () => {
      $$(
        document,
        '[data-ak-builder][data-ak-builder-ready="true"]'
      ).forEach(
        refreshSummary
      );
    }
  );

  window.addEventListener(
    'pageshow',
    syncCartTotals
  );

  function initializeAll() {
    $$(
      document,
      '[data-ak-builder]'
    ).forEach(
      initialize
    );
  }

  function start() {
    initializeAll();

    new MutationObserver(
      initializeAll
    ).observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true
      }
    );
  }

  else {
    start();
  }
})();


(() => {
  if (
    window
      .AKBuilderCompactV60Installed
  ) {
    return;
  }

  window
    .AKBuilderCompactV60Installed =
    true;

  const builders =
    new WeakSet();

  const styles =
    document.createElement(
      'style'
    );

  styles.textContent = `
    .ak-builder:not(.ak-builder--editing)
    .ak-builder__list
    [data-ak-builder-item]:not(.is-selected):not(.ak-builder--recently-removed) {
      display: none !important;
    }

    .ak-builder:not(.ak-builder--editing)
    .ak-builder__list
    [data-ak-builder-item].ak-builder--recently-removed {
      display: flex !important;
      opacity: .62;
    }

    .ak-builder.ak-builder--editing
    .ak-builder__list {
      max-height: 310px;
      overflow-y: auto;
      overscroll-behavior: contain;
      scrollbar-width: thin;
    }

    .ak-builder__compact-toggle {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      min-height: 44px;
      margin: 12px 0 0;
      padding: 10px 12px;
      border: 1px solid #e7dbea;
      border-radius: 11px;
      background: #fff;
      color: #754188;
      font: inherit;
      font-size: 12px;
      font-weight: 700;
      cursor: pointer;
    }

    .ak-builder__compact-toggle:hover {
      background: #faf6fc;
    }

    .ak-builder__compact-toggle:focus-visible {
      outline: 2px solid #955db0;
      outline-offset: 2px;
    }

    @media (max-width: 749px) {
      .ak-builder.ak-builder--editing
      .ak-builder__list {
        max-height: 280px;
      }
    }
  `;

  document.head.appendChild(
    styles
  );

  function $(
    parent,
    selector
  ) {
    return parent
      .querySelector(
        selector
      );
  }

  function label(
    builder
  ) {
    const button =
      $(
        builder,
        '.ak-builder__compact-toggle'
      );

    if (!button) {
      return;
    }

    button.textContent =
      builder.classList
        .contains(
          'ak-builder--editing'
        )
        ? builder.dataset
            .labelEditClose ||
          ''
        : builder.dataset
            .labelEditOpenOther ||
          '';

    button.setAttribute(
      'aria-expanded',
      String(
        builder.classList
          .contains(
            'ak-builder--editing'
          )
      )
    );
  }

  function setup(
    builder
  ) {
    if (
      builders.has(
        builder
      )
    ) {
      return;
    }

    const list =
      $(
        builder,
        '.ak-builder__list'
      );

    if (
      !list ||
      !list.querySelector(
        '[data-ak-builder-item]'
      )
    ) {
      return;
    }

    builders.add(
      builder
    );

    const button =
      document
        .createElement(
          'button'
        );

    button.type =
      'button';

    button.className =
      'ak-builder__compact-toggle';

    list.insertAdjacentElement(
      'afterend',
      button
    );

    button.addEventListener(
      'click',
      () => {
        builder.classList
          .toggle(
            'ak-builder--editing'
          );

        label(
          builder
        );
      }
    );

    label(
      builder
    );
  }

  function init() {
    document
      .querySelectorAll(
        '[data-ak-builder]'
      )
      .forEach(
        setup
      );
  }

  document.addEventListener(
    'change',
    event => {
      const builder =
        event.target
          .closest?.(
            '[data-ak-builder]'
          );

      if (builder) {
        requestAnimationFrame(
          () =>
            label(
              builder
            )
        );
      }
    }
  );

  document.addEventListener(
    'click',
    event => {
      const size =
        event.target
          .closest?.(
            '[data-ak-builder-size]'
          );

      const builder =
        size?.closest(
          '[data-ak-builder]'
        );

      if (builder) {
        requestAnimationFrame(
          () => {
            builder.classList
              .remove(
                'ak-builder--editing'
              );

            label(
              builder
            );
          }
        );
      }
    }
  );

  function start() {
    init();

    new MutationObserver(
      init
    ).observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true
      }
    );
  }

  else {
    start();
  }
})();


(() => {
  if (
    window
      .AKBuilderAnalyticsV2Installed
  ) {
    return;
  }

  window
    .AKBuilderAnalyticsV2Installed =
    true;

  window.dataLayer =
    window.dataLayer ||
    [];

  const viewed =
    new WeakSet();

  let pendingAdd =
    null;

  function data(
    builder
  ) {
    return {
      builder_product_id:
        builder?.dataset
          .productId ||
        '',

      builder_main_variant_id:
        builder?.dataset
          .mainVariantId ||
        '',

      builder_variant_count:
        Array.isArray(
          builder
            ?.akSelectedVariants
        )
          ? builder
              .akSelectedVariants
              .length
          : 0,

      builder_value:
        Number.isFinite(
          builder
            ?.akSelectedTotal
        )
          ? builder
              .akSelectedTotal /
            100
          : null,

      currency:
        builder?.dataset
          .currency ||
        'EUR'
    };
  }

  function push(
    event,
    payload = {}
  ) {
    window.dataLayer
      .push({
        event,
        ...payload
      });
  }

  const observer =
    new IntersectionObserver(
      entries => {
        entries
          .forEach(
            entry => {
              if (
                !entry
                  .isIntersecting ||
                viewed.has(
                  entry.target
                )
              ) {
                return;
              }

              viewed.add(
                entry.target
              );

              push(
                'builder_view',
                data(
                  entry.target
                )
              );

              observer
                .unobserve(
                  entry.target
                );
            }
          );
      },
      {
        threshold:
          0.5
      }
    );

  function observe() {
    document
      .querySelectorAll(
        '[data-ak-builder]'
      )
      .forEach(
        builder => {
          if (
            !viewed.has(
              builder
            )
          ) {
            observer.observe(
              builder
            );
          }
        }
      );
  }

  document.addEventListener(
    'click',
    event => {
      const size =
        event.target
          .closest?.(
            '[data-ak-builder-size]'
          );

      if (size) {
        const builder =
          size.closest(
            '[data-ak-builder]'
          );

        if (builder) {
          push(
            'builder_size_select',
            {
              ...data(
                builder
              ),

              builder_size:
                size.dataset
                  .akBuilderSize ||
                ''
            }
          );
        }
      }

      const edit =
        event.target
          .closest?.(
            '.ak-builder__compact-toggle'
          );

      if (
        edit &&
        edit.getAttribute(
          'aria-expanded'
        ) !== 'true'
      ) {
        const builder =
          edit.closest(
            '[data-ak-builder]'
          );

        if (builder) {
          push(
            'builder_edit_open',
            data(
              builder
            )
          );
        }
      }

      const add =
        event.target
          .closest?.(
            '[data-ak-builder-add]'
          );

      if (add) {
        const builder =
          add.closest(
            '[data-ak-builder]'
          );

        if (builder) {
          pendingAdd = {
            builder,
            data:
              data(
                builder
              )
          };
        }
      }
    }
  );

  document.addEventListener(
    'change',
    event => {
      const checkbox =
        event.target;

      if (
        !checkbox.matches?.(
          '[data-ak-builder-check]'
        )
      ) {
        return;
      }

      const builder =
        checkbox.closest(
          '[data-ak-builder]'
        );

      const row =
        checkbox.closest(
          '[data-ak-builder-item]'
        );

      if (
        !builder ||
        !row
      ) {
        return;
      }

      push(
        'builder_product_toggle',
        {
          ...data(
            builder
          ),

          builder_variant_id:
            row.dataset
              .variantId ||
            '',

          builder_crystal_key:
            row.dataset
              .crystalKey ||
            '',

          builder_product_role:
            row.dataset
              .akRole ||
            '',

          builder_action:
            checkbox.checked
              ? 'add'
              : 'remove'
        }
      );
    }
  );

  document.addEventListener(
    'cart:refresh',
    event => {
      if (
        event.detail?.source !==
          'ak-crystal-builder' ||
        !pendingAdd
      ) {
        return;
      }

      push(
        'builder_add_to_cart',
        pendingAdd.data
      );

      pendingAdd =
        null;
    }
  );

  function start() {
    observe();

    new MutationObserver(
      observe
    ).observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true
      }
    );
  }

  else {
    start();
  }
})();